import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function clearSessionData() {
  // Clear cookies (example using js-cookie)
  //Cookies.remove('supabase.auth.token'); // Replace with your actual cookie name

  // Clear local storage
  localStorage.removeItem('supabase.auth.token'); // Replace with your actual local storage key
  localStorage.clear(); //Clears all local storage, use with caution
}
